import React from 'react'
import { Form, Select } from 'antd'

import I18n from '../../i18n';

type PropsType = {
  onChangeAllPermissions: any
}
// Marcar todos os ítens com permissão para
class PermissionsChangeAll extends React.Component<PropsType> {
  render() {
    return (
      <Form labelCol={{ xs: { span: 9 } }} wrapperCol={{ xs: { span: 15 } }}>
        <Form.Item label={I18n.l('permissions.createGroupModal.changeAllPermissions')} className="form-change-all">
          <Select onChange={this.props.onChangeAllPermissions}>
            <Select.Option value={1}>{I18n.l('permissions.createGroupModal.optionAll')}</Select.Option>
            <Select.Option value={2}>{I18n.l('permissions.createGroupModal.optionMine')}</Select.Option>
            <Select.Option value={3}>{I18n.l('permissions.createGroupModal.optionNone')}</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    )
  }
}

export default PermissionsChangeAll